import OperateInspectionMonitorHome from './views/Home.vue'
import OperateInspectionMonitor from './views/Inspection.vue'
import OperateInspectionMonitorDetail from './views/InspectionDetail.vue'

export default {
  routes: [
    {
      path: '/operate/inspection_monitor',
      component: OperateInspectionMonitorHome,
      name: 'OperateInspectionMonitorHome',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'inspections',
          component: OperateInspectionMonitor,
          name: 'OperateInspectionMonitor',
        },
        {
          path: 'inspections/:id([0-9]+)',
          component: OperateInspectionMonitorDetail,
          name: 'OperateInspectionMonitorDetail',
          props: (route) => ({ id: Number(route.params.id) }),
        },
      ],
    },
  ],
}
